import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleStyle } from './contactCell.css';

type Props = {
  name: string;
};

export const ContactNameCell = ({ name }: Props) => {
  return <div className={clsx(titleStyle, desktopTruncateStyle)}>{name.trim() || '-'}</div>;
};
